// src/components/Like/Like.jsx
import React, { useState } from "react";
import "./Like.css";

const Like = ({ post }) => {
  // isLiked 是否已点赞，likeCount 点赞数量
  const [isLiked, setIsLiked] = useState(false);
  const [likeCount, setLikeCount] = useState(post?.likes || 0);

  const handleLike = () => {
    if (isLiked) {
      setIsLiked(false);
      setLikeCount((prev) => prev - 1); // 修正这一行
    } else {
      setIsLiked(true);
      setLikeCount((prev) => prev + 1); // 修正这一行
    }
  };

  return (
    <button className="like-btn" onClick={handleLike}>
      <span className={`like-icon ${isLiked ? "liked" : ""}`}>
        {isLiked ? "❤️" : "🤍"}
      </span>
      <span className="like-count">{likeCount}</span>
    </button>
  );
};

export default Like;
